export default class Api {
  constructor(el, opt) {
    this.el = el
    this.$el = $(el)
    this.defaults = {
      block: 'square',
      size: 'small'
    }
    this.settings = Object.assign({}, this.defaults, opt)
  }

  /**
   * @method 获取所有组件
   * @description 取出组件在this.settings.objs中的缓存
   * @param void
   * @returns 组件缓存 :object
   */
  get objs() {
    return this.settings.objs
  }

  /**
   * @method 获取单个控件的对象
   * @description 取出组件在this.settings.objs中的缓存
   * @deprecated form.objs.name 可以达到相同效果
   * @param name:string 组件的name
   * @returns :object 对象
   */
  getEle(name) {
    return this.objs[name]
  }

  destroy() {
    const com = this.$el.find('.form__inner')
    com.empty()
    com.remove()
  }

  /**
   * @method 填充表单
   * @description 遍历表单元素,根据数据的key,循环添加至name为key的控件中去
   * @param data :object 源数据
   * @returns this 链式调用
   */
  fill(data) {
    if ($.type(data) === 'object') {
      const objs = this.objs
      this.clear()
      Object.keys(objs).map(key => {
        const item = objs[key]
        const val = data[key]
        if (val) item.value = val
      })
    }
    return this
  }

  /**
   * @method 获取表单数据(注:被禁用对象不会被取值)
   * @description 遍历表单元素,以name为key,value为value,返回新对象
   * @param void
   * @returns data :object 所有组件的值
   */
  getData() {
    const objs = this.objs
    const data = {}
    Object.keys(objs).map(key => {
      const item = objs[key]
      if (!item.disabled) data[key] = item.value
    })
    return data
  }

  /**
   * @method 获取指定组件数据
   * @description 通过调用组件缓存对象,获取对象的value属性
   * @deprecated form.objs.name.value 可以达到相同的效果
   * @param name:string 组件的name
   * @returns value :string 组件的值
   */
  getValue(name) {
    const objs = this.objs
    return objs[name] ? objs[name].value : ''
  }

  /**
   * @method 设置指定组件数据的值
   * @description 通过调用组件缓存对象,对象的value属性赋值
   * @deprecated form.objs.name.value = val 可以达到相同的效果
   * @param name:string 组件的name  val:string 组件的值
   * @returns this 链式调用
   */
  setValue(name, val) {
    const objs = this.objs
    const input = objs[name]
    if (input) input.value = val
    // if (name in this.memory) input.trigger()
    return this
  }

  /**
   * @method 清除表单值
   * @description 除了指定name的其他组件,执行清空操作
   * @param ...name:string 多个name的的集合
   * @returns this 链式调用
   */
  clearExcept(...name) {
    const objs = this.objs
    Object.keys(objs)
      .filter(key => !name.includes(key))
      .map(key => objs[key].clear())
    return this
  }

  /**
   * @method 清除表单值
   * @description 指定name的组件,执行清空操作
   * @param ...name:string 多个name的的集合
   * @returns this 链式调用
   */
  clear(...name) {
    this._doSomething('value', '', ...name)
    return this
  }

  /**
   * @method 隐藏表单,不可见
   * @description 指定name的组件,执行隐藏操作
   * @param ...name:string 多个name的的集合
   * @returns this 链式调用
   */
  hide(...name) {
    this._doSomething('visible', false, ...name)
    return this
  }

  /**
   * @method 显示表单,可见
   * @description 指定name的组件,执行显示操作
   * @param ...name:string 多个name的的集合
   * @returns this 链式调用
   */
  show(...name) {
    this._doSomething('visible', true, ...name)
    return this
  }

  /**
   * @method 禁用表单,不可输入
   * @description 指定name的组件,执行显示操作
   * @param ...name:string 多个name的的集合
   * @returns this 链式调用
   */
  disable(...name) {
    this._doSomething('disabled', true, ...name)
    return this
  }

  /**
   * @method 启用表单,可输入
   * @description 指定name的组件,执行显示操作
   * @param ...name:string 多个name的的集合
   * @returns this 链式调用
   */
  enable(...name) {
    this._doSomething('disabled', false, ...name)
    return this
  }

  /**
   * @method 启用预览表单,不可编辑
   * @description 指定name的组件,执行显示操作
   * @param ...name:string 多个name的的集合
   * @returns this 链式调用
   */
  viewOn(...name) {
    this._doSomething('editable', false, ...name)
    return this
  }

  /**
   * @method 关闭预览表单,可编辑
   * @description 指定name的组件,执行显示操作
   * @param ...name:string 多个name的的集合
   * @returns this 链式调用
   */
  viewOff(...name) {
    this._doSomething('editable', true, ...name)
    return this
  }

  checkValid() {
    this._doSomething('valid', true, ...name)
    return this
  }

  clearValid() {
    this._doSomething('valid', false, ...name)
    return this
  }

  /**
   * @method 多控件操作
   * @description 通过遍历缓存组件,调用对应的单组件方法
   * @private
   * @param fn:string 单组件可操作属性 val:any 属性值 ...name:string 多个name的的集合
   * @returns void
   */
  _doSomething(fn, val, ...name) {
    const objs = this.objs
    if (name.length) {
      Object.keys(objs)
        .filter(key => name.includes(key))
        .map(key => {
          objs[key][fn] = val
        })
    } else {
      Object.keys(objs).map(key => {
        objs[key][fn] = val
      })
    }
  }
}
